import * as React from 'react';
import { Tag } from '../../internal/components/Tag';
import styles from './styles.module.css';

/**
 * [Ссылка на макет](https://www.figma.com/design/4UM8zoowH9YGMM7fSK0rhD/%F0%9F%8C%90-Web-Components?node-id=33981-23326&node-type=frame&t=dWJSsCGr4smKrzpW-0)
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const Tags = props => {
  const {
    onClose,
    options,
    size
  } = props;
  return /*#__PURE__*/_jsx("div", {
    className: styles['tags'],
    children: /*#__PURE__*/_jsx("div", {
      className: styles['tags_wrapper'],
      children: options.map(option => /*#__PURE__*/_jsx("div", {
        className: styles['tags_item'],
        children: /*#__PURE__*/_jsx(Tag, {
          onClose: () => onClose(option),
          size: size,
          children: option.label
        })
      }, option.value))
    })
  });
};
Tags.displayName = 'Tags';